import * as React from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'

interface Props {
  onClose: () => void
}

export class PricingGroupHelpModal extends React.Component<Props, {}> {
  render() {
    return (
      <Modal isOpen={true} toggle={() => this.props.onClose()} size='lg'>
        <ModalHeader toggle={() => this.props.onClose()}>About pricing groups</ModalHeader>
        <ModalBody>
          <p>
            If you have a large number of products, and you want to adjust their prices all at once,
            it can be very difficult to do.
          </p>
          <p>
            GetGreenline's pricing groups feature helps you manage different groups of prices to
            update from one spot
          </p>
          <p>To start:</p>
          <ul>
            <li>Create a pricing group on the 'pricing groups' page on the left-hand menu</li>
            <li>Click into a product you want to attach, and select the pricing group</li>
            <li>Save your product before proceeding with any further edits</li>
          </ul>
          <p>
            You will notice that after attaching to a pricing group, certain fields are not
            editable. That is because they are carried over from the pricing group.
          </p>
          <p>The fields carried over from pricing groups are:</p>
          <ul>
            <li>Unit of measurement</li>
            <li>Whether or not a product has variants</li>
            <li>All prices</li>
            <li>All weights</li>
            <li>Variant names</li>
            <li>Inventory tracking mode</li>
          </ul>
          <p>
            <b>IMPORTANT NOTE:</b> If you are editing an existing product, please note that SKUs,
            labels, descriptions, and WooCommerce product ID fields will be cleared - you must
            re-enter that data afterwards.
          </p>
        </ModalBody>
      </Modal>
    )
  }
}
